import { SortType } from '../sorting';

export const RECORD_COMMENTS_INFO = {
  DEFAULT_SORT_TYPE: SortType.Asc,
  // 'asc' | 'desc'
  COOKIES_SORT_TYPE_KEY: 'fnt_comments_sorting',
  COMMENT_ID_HASH_PREFIX: 'comment_id_',
  DISCUSS_HASH: 'discuss'
};
